// extracted by mini-css-extract-plugin
module.exports = {"bar":"styles_bar__cjdBw"};